//DEPENDENCIES
import React, { useState, useEffect } from 'react';
//COMPONENTS
import { Link, useParams } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { Spinner } from 'react-bootstrap';
//SERVICES AND HELPERS
import * as jobService from '../../../services/service/jobService';

const ClientJobListingPage = (props) => {
  const { history } = props;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    jobService
      .getJobsByClient(id)
      .then((res) => {
        setData(res);
      })
      .catch((ex) => {
        console.log('Error is ', ex);
      })
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        width: 1,
        print: false,
        download: false,
        setCellProps: () => ({
          'data-aes-field': 'actions',
          'data-aes-label': 'Actions',
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className='aes-admin-listing-actions'>
              <Link
                to={'/services/manage-job/general-information/' + data[dataIndex].id}
                href='#'
                className='btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5'
              >
                View
              </Link>
            </div>
          );
        },
      },
    },
    {
      name: 'proposal.projectNumber',
      label: 'Project#',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'primary',
          'data-aes-label': 'Project Number',
        }),
        customBodyRenderLite: (dataIndex) => {
          return <p>{data[dataIndex].proposal ? data[dataIndex].proposal.projectNumber : '-'}</p>;
        },
      },
    },
    {
      name: 'proposal.projectName',
      label: 'Project Name',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'detail',
          'data-aes-label': 'Project Name',
        }),
        customBodyRenderLite: (dataIndex) => {
          return <p>{data[dataIndex].proposal ? data[dataIndex].proposal.projectName : '-'}</p>;
        },
      },
    },
  ];

  return (
    <div className='card card-custom card-stretch aes-admin-listing-page aes-admin-listing-page--client-jobs'>
      <div className='card-header py-3'>
        <div className='card-title align-items-start flex-column'>
          <h3 className='card-label font-weight-bolder text-dark'>Job List</h3>
          <span className='text-muted font-weight-bold fz-xs mt-1'>View/Edit jobs for thisclient</span>
        </div>
        <div className='card-toolbar'>
          <a onClick={() => history.goBack()} className='btn btn-secondary'>
            Cancel
          </a>
        </div>
      </div>
      <div className='form aes-admin-listing'>
        <div className='card-body px-0'>
          <MUIDataTable
            className='aes-admin-listing-surface'
            data={data}
            columns={columns}
            options={{
              responsive: 'standard',
              rowsPerPage: 25,
              rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
              selectableRows: 'none',
              setTableProps: () => ({
                className: 'aes-admin-listing-table',
              }),
              downloadOptions: {
                filename: 'Client_Jobs.csv',
                filterOptions: {
                  useDisplayedColumnsOnly: true,
                  useDisplayedRowsOnly: true,
                },
              },
              textLabels: {
                body: {
                  noMatch: loading ? <Spinner animation='border' size='lg' variant='info' /> : 'Sorry, no matching records found.',
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientJobListingPage;
